import React from 'react'
import logo from '../img/logo.jpg';

const Present = () => {
    return (
        <div className='present'>

            <div className='present2' >
                <img src={logo}  />
            </div>
           

          

            <div className='present2 garima  files'>

                <h1> DR. NEERJA SINGH  </h1>
                <p>  Eldeco Green Woods Colony Malhaur <br/>Road Gomti Nagar  Chinhat  Lucknow, 226028</p>
            </div>
           

            <div className='present2 calls files'>
                <h1>CONTACT US  </h1>
                <p>clinicneerja@gmail.com</p>
                <p style={{marginTop:'-15px'}}>+91 7081000958 , 7081000959 </p>
              
               

            </div>
        </div>
    )
}

export default Present